import { cn } from '@endure/ui';
import type { Token } from 'types';

import { InfoIcon } from 'components/InfoIcon';
import { Icon, type IconName } from '../Icon';
import { TokenIcon } from '../TokenIcon';

export interface LabeledInlineContentProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  tooltip?: React.ReactNode;
  children: React.ReactNode;
  invertTextColors?: boolean;
  iconSrc?: IconName | Token;
  iconClassName?: string;
  labelClassName?: string;
}

export const LabeledInlineContent = ({
  label,
  tooltip,
  iconSrc,
  iconClassName,
  invertTextColors = false,
  children,
  className,
  labelClassName,
  ...otherContainerProps
}: LabeledInlineContentProps) => (
  <div className={cn('flex w-full justify-between space-x-4', className)} {...otherContainerProps}>
    <div className={cn('flex items-center text-sm', labelClassName)}>
      {typeof iconSrc === 'string' && (
        <Icon name={iconSrc} className={cn('-mt-[2px] mr-2 h-5 w-5', iconClassName)} />
      )}

      {!!iconSrc && typeof iconSrc !== 'string' && (
        <TokenIcon token={iconSrc} className="-mt-[2px] mr-2 h-5 w-5" />
      )}

      <div className={cn('text-sm', invertTextColors ? 'text-white' : 'text-grey')}>{label}</div>

      {!!tooltip && <InfoIcon className="ml-2 inline-flex items-center" tooltip={tooltip} />}
    </div>

    <div className={cn('flex items-center text-sm', invertTextColors ? 'text-grey' : 'text-white')}>
      {children}
    </div>
  </div>
);
